import { useEffect, useState } from 'react';
import { WEIGHT_UNIT } from '../../../../types/enum';
import { convertWeight } from '../../../../lib/utils';
import request from '../../../../lib/request';
import CurrentGoal from './currentGoal';
import ResetGoal from './reset';
import usePreference from '../../../../hook/usePreference';

const Goal = ({ user }) => {
  const { preference } = usePreference();

  const [resetGoal, setResetGoal] = useState(false);
  const [goal, setGoal] = useState({});

  useEffect(() => {
    if (!resetGoal) {
      getUserGoal();
    }
  }, [resetGoal, preference]);

  const getUserGoal = async () => {
    try {
      const { result } = await request.get('/user/goal');
      if (result && result.length > 0) {
        const currentGoal = result[0];
        currentGoal.weight =
          preference.weightUnit === WEIGHT_UNIT.LB
            ? convertWeight(currentGoal.weight, WEIGHT_UNIT.KG, WEIGHT_UNIT.LB)
            : currentGoal.weight;
        setGoal(currentGoal);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleResetGoal = () => {
    setResetGoal(true);
  };

  return resetGoal ? (
    <ResetGoal
      user={user}
      setResetGoal={setResetGoal}
    />
  ) : (
    <div>
      <CurrentGoal
        goal={goal}
        user={user}
        getUserGoal={getUserGoal}
        preference={preference}
      />
      <div className='flex justify-center mt-8'>
        <button
          className='font-bold text-sm text-accent'
          onClick={handleResetGoal}
        >
          Set New Goals
        </button>
      </div>
    </div>
  );
};

export default Goal;
